import React from "react";
import { Box, Typography, Paper, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

//TOOD: Refacto to use grid 2 instead and use styles in appInfoSectionStyled
const AppInfoSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: <RestaurantIcon color="primary" />,
      title: t("appInfoSection.Store And Discover Recipes"),
      description: t("appInfoSection.storeAndDiscoverRecipesDesc"),
    },
    {
      icon: <CalendarMonthIcon color="primary" />,
      title: t("appInfoSection.Weekly Menu Planning"),
      description: t("appInfoSection.weeklyMenuPlanningDesc"),
    },
    {
      icon: <FormatListBulletedIcon color="primary" />,
      title: t("appInfoSection.Frequent Items Lists"),
      description: t("appInfoSection.frequentItemsListsDesc"),
    },
    {
      icon: <ShoppingCartIcon color="primary" />,
      title: t("appInfoSection.Smart Shopping Lists"),
      description: t("appInfoSection.smartShoppingListsDesc"),
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 2,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography
        variant="h5"
        component="h2"
        sx={{
          mb: 2,
          fontWeight: 500,
          color: "primary.main",
        }}
      >
        {t("appInfoSection.welcomeToRecipeVault")}
      </Typography>

      <Typography variant="body1" sx={{ mb: 3 }}>
        {t("appInfoSection.appDescription")}
      </Typography>

      <Grid container spacing={2}>
        {features.map((feature, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                p: 2,
                borderRadius: 1,
                transition: "all 0.3s ease",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.02)",
                },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                {feature.icon}
                <Typography
                  variant="subtitle1"
                  component="h3"
                  sx={{
                    ml: 1,
                    fontWeight: 500,
                  }}
                >
                  {feature.title}
                </Typography>
              </Box>
              <Typography variant="body2" color="text.secondary">
                {feature.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Login Call-to-Action */}
      <Box
        sx={{
          mt: 4,
          pt: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: "primary.main",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {t("appInfoSection.loginPrompt")}
        </Typography>
      </Box>
    </Paper>
  );
};

export default AppInfoSection;
